document.addEventListener('DOMContentLoaded', function() {
    function updateFreeShippingProgress(cart) {
        document.querySelectorAll('.cart-shipping-progress').forEach((progress) => {
            if (!progress || !cart) return;

            const threshold = Number(
                progress.dataset.freeShippingThreshold
            );

            const successMessage =
                progress.dataset.successMessage;

            const remainingMessage =
                progress.dataset.remainingMessage;

            const subtotal = cart.total_price || 0;

            const remaining = Math.max(
                threshold - subtotal,
                0
            );

            const percentage = Math.min(
                (subtotal / threshold) * 100,
                100
            );

            const fill = progress.querySelector(
                '[data-free-shipping-fill]'
            );

            const message = progress.querySelector(
                '[data-free-shipping-message]'
            );

            fill.style.width = `${percentage}%`;

            if (remaining <= 0) {
                message.textContent = successMessage;
            } else {
                message.innerHTML =
                `You're <strong>${theme.Currency.formatMoney(
                    remaining
                )}</strong> ${remainingMessage}`;
            }
        });        
    }

    function getCartAndUpdateProgress() {
        fetch('/cart.js')
            .then((response) => response.json())
            .then((cart) => {
            updateFreeShippingProgress(cart);
            });
    }

    document.addEventListener('drawerOpen', function(evt) {
        getCartAndUpdateProgress();
    })

    document.addEventListener('cart:updated', function(evt) {
        if (evt.detail?.cart) {
            updateFreeShippingProgress(evt.detail.cart);
        }
    });

    getCartAndUpdateProgress();

})